import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const WHATSAPP_NUMBER = "919876543210";
export const WHATSAPP_BASE = `https://wa.me/${WHATSAPP_NUMBER}`;

export const WA_LINKS = {
  healthCheck: `${WHATSAPP_BASE}?text=${encodeURIComponent("Hi AssetCare365, I'd like to book my free Property Health Check.")}`,
  call: `${WHATSAPP_BASE}?text=${encodeURIComponent("Hi AssetCare365, I'd like to book a 15-minute call with a property expert.")}`,
  general: `${WHATSAPP_BASE}?text=${encodeURIComponent("Hi AssetCare365, I'd like to know more about your services.")}`
};

export const CONTACT = {
  email: "assetcare365@gmail.com",
  phone: "+91 9958150131",
  hq: "New Delhi, India"
};